<div class="counts-grid"
  [style.grid-template-columns]="'repeat(' + counts?.length + ', 1fr)'">
  @for (item of counts; track item) {
    <sb-text
      customClasses="stats-grid__heading"
      [textClass]="item.className"
    [message]="item.name"></sb-text>
  }
  @for (item of counts; track item) {
    <sb-text
      customClasses="semi-bold"
      [textClass]="item.className"
    [message]="item.value.toString()"></sb-text>
  }
</div>
